export const HttpMethod = Object.freeze({
  DELETE: "DELETE",
  GET: "GET",
  HEAD: "HEAD",
  PATCH: "PATCH",
  POST: "POST",
  PUT: "PUT",
});

export const HttpStatus = Object.freeze({
  BAD_GATEWAY: 502,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  CREATED: 201,
  FORBIDDEN: 403,
  GATEWAY_TIMEOUT: 504,
  GONE: 410,
  INTERNAL_SERVER_ERROR: 500,
  NO_CONTENT: 204,
  NOT_FOUND: 404,
  OK: 200,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422,
});

export const ContentType = Object.freeze({
  EVENT_STREAM: "text/event-stream",
  JSON: "application/json",
});

export const HeaderName = Object.freeze({
  ACCEPT: "Accept",
  CONTENT_TYPE: "Content-Type",
  CSRF_TOKEN: "X-CSRF-Token",
});

const SAFE_METHODS = new Set([HttpMethod.GET, HttpMethod.HEAD]);

export function isWriteMethod(method) {
  return !SAFE_METHODS.has(method.toUpperCase());
}

export function isSafeMethod(method) {
  return SAFE_METHODS.has(method.toUpperCase());
}

export const REQUEST_TIMEOUT_MS = 30_000;

export function isRawBody(body) {
  return (
    typeof body === "string" ||
    body instanceof Blob ||
    body instanceof FormData ||
    body instanceof URLSearchParams ||
    body instanceof ArrayBuffer ||
    ArrayBuffer.isView(body)
  );
}

export class HttpError extends Error {
  constructor(message, { status, data, cause } = {}) {
    super(message, { cause });
    this.name = "HttpError";
    this.status = status;
    this.data = data;
  }
}
